import React, { useState, useEffect } from 'react';
import { Container, Grid, FormControlLabel, Button } from '@material-ui/core';
import { CustomeAlert } from 'Components/Alert/Alert';
import {
    LOGOUT,
    SMS_ACTIVATE,
    SMS_SELECT_LIST,
    SMS_DELETE
} from 'ConstComponents';
import Switch from '@material-ui/core/Switch';

import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ReactTable from 'Components/ReactTable/ReactTable';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import Backdrop from '@material-ui/core/Backdrop';
import { useHistory } from 'react-router';
import Loader from 'Components/Loader/Loader';
import Box from '@material-ui/core/Box';
import { ConfirmAlert } from 'Components/Alert/ConfirmAlert';

export const Sms = () => {
    const classes = commonStyle();
    const history = useHistory();
    const [sms, setSms] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});

    const onClick = item => {
        var RequestObj = { SmsID: item };
        setIsAlertOpen(true);
        setConfirmAlertRequest(RequestObj);
    };

    const activate = async (item, value) => {
        var jsonObj = {
            SmsID: item,
            IsActive: value
        };
        var request = JSON.stringify(jsonObj);
        setIsError(false);
        setLoadingOpen(true);

        const response = await SMS_ACTIVATE(request);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        setSeverity('success');
        setResponseMessage(response.data);

        if (!response.status) setSeverity('error');

        setIsError(true);
        selectSms();
    };

    const selectSms = async () => {
        const response = await SMS_SELECT_LIST();
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setResponseMessage(response.data);
            setSeverity('error');
            return;
        }

        var data = JSON.parse(response.data);
        setSms(data);
    };

    useEffect(() => {
        selectSms();
        createColumns();
    }, []);

    const Delete = async request => {
        setIsError(false);
        setLoadingOpen(true);
        var jsonReq = JSON.stringify(request);
        const response = await SMS_DELETE(jsonReq);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();
        setSeverity('success');
        setResponseMessage(response.data);

        if (!response.status) setSeverity('error');

        setIsError(true);
        selectSms();
    };
    const EditSms = async request => {
        history.push('/SMS/Edit/' + request);
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'SmsID',
            srno: true
        });

        columns.push({
            label: 'SMS URL',
            name: 'SmsString'
        });

        columns.push({
            label: 'Balance Check URL',
            name: 'BalanceCheckUrl'
        });

        columns.push({
            label: 'Active',
            name: 'IsActive',
            options: {
                filter: false,
                sort: false,
                download: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const SmsID = tableMeta.rowData[0];
                    return (
                        <FormControlLabel
                            value={value ? 'Yes' : 'No'}
                            control={
                                <Switch
                                    color="primary"
                                    checked={value}
                                    value={value ? 'Yes' : 'No'}
                                />
                            }
                            onChange={event => {
                                var newValue =
                                    event.target.value === 'Yes' ? false : true;
                                updateValue(newValue);
                                activate(SmsID, newValue);
                            }}
                        />
                    );
                }
            }
        });

        columns.push({
            label: 'Edit',
            name: 'SmsID',
            options: {
                filter: false,
                sort: false,
                download: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <EditIcon
                            variant="contained"
                            color="primary"
                            onClick={event => {
                                EditSms(value);
                            }}
                        />
                    );
                }
            }
        });

        columns.push({
            label: 'Delete ',
            name: 'SmsID',
            options: {
                filter: false,
                sort: false,
                download: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <DeleteIcon
                            color="secondary"
                            variant="contained"
                            onClick={event => {
                                onClick(value);
                            }}
                        />
                    );
                }
            }
        });

        setMainColumns(columns);
    };

    return (
        <>
            {isError ? (
                <CustomeAlert
                    isOpen={isError}
                    message={responseMessage}
                    severity={severity}
                    onCloseCallback={alertState => {
                        setIsError(alertState);
                    }}
                />
            ) : null}

            {isAlertOpen ? (
                <ConfirmAlert
                    isOpen={isAlertOpen}
                    title="Delete Confirmation"
                    message="Are you sure to delete this SMS."
                    request={confirmAlertRequest}
                    positiveButtonClick={request => {
                        setIsAlertOpen(false);
                        Delete(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}

            <Backdrop className={classes.backdrop} open={loadingOpen}>
                <Loader />
            </Backdrop>

            <Grid style={{ marginBottom: '5px', marginTop: '5px' }}>
                <Box display="flex" flexDirection="row-reverse">
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.CustomPrimaryButtonStyle}
                        href="/Sms/Add"
                    >
                        New SMS
                    </Button>
                </Box>
            </Grid>

            <ReactTable List={sms} columns={mainColumns} />
        </>
    );
};
